(ns minorodata.components.connections.extract-edit-form
  (:require
   [minorodata.app.api-config :refer [API_HOST]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :as app.utils]
   [minorodata.components.connections.forms.generator :as form-generator]
   [re-posh.core :as re-posh]))


(def downstream-config-doc
  [:span "Supported only for scheduled executions"])

(defn has-downstream-config? [form]
  (some #(= :downstream-config (:block-type %)) (:blocks form)))

;; For now hardcoding the downstream config block
;; Might move to db in the future
(defn maybe-add-downstream-config-blocks [form source-id]
  (let [uses-temporal @(re-posh/subscribe [:source/prop [:source/source-id source-id] :source/uses-temporal])
        enabled?      @(re-posh/subscribe [:unleash/is-enabled "extract-kickoff-downstream"])]
    (cond-> form
      (and enabled?
           uses-temporal
           ;; Make sure not to duplicate if set in DB
           (not (has-downstream-config? form)))
      (update :blocks (fn [blocks]
                        (concat (butlast blocks)
                                [{:block-type :subtitle :content "Run downstream"
                                  :doc        downstream-config-doc}
                                 {:block-type :downstream-config :name :downstream-config}]
                                [(last blocks)]))))))

(defn submit-extract-config [source-id extract-id current extract-details-drawer?]
  (fn [params]
    (let [{:app-route/keys [name]} @(re-posh/subscribe [:app-route/pull])
          {:extract/keys [schedule-spec]} current
          cron          (:cron schedule-spec)
          has-schedule? (and cron (not= app.utils/empty-cron cron))
          data          (app.utils/assoc-some params
                                              :schedule-spec
                                              (when has-schedule? {:cron cron}))]
      (dispatch [:connections.api/edit-extract
                 {:source-id                source-id
                  :extract-id               extract-id
                  :data                     data
                  :extract-details-drawer?  extract-details-drawer?
                  :on-success (when (= :dag name)
                                #(dispatch [:dag/load-dag-data]))}]))))

(defn extract-form-definition [extract source]
  (let [{:extract/keys [source-id config]} extract
        connectors @(re-posh/subscribe [:connections.subs/all-connectors])
        version    (get-in config [:extracts 0 :version])
        connector  (app.utils/find-connector-by-type-and-version
                    connectors
                    (:source/source-type source)
                    version)]
    (maybe-add-downstream-config-blocks
     (:extract-form connector)
     source-id)))

(defn extract-edit-form
  [{:keys [extract source on-close extract-details-drawer?]}]
  (let [{:extract/keys [source-id extract-id client-id]} extract
        form-definition (extract-form-definition extract source)]
    (when form-definition
      [form-generator/generate
       form-definition
       {:on-close       on-close
        :initial-values extract
        :kleene-globals {:client-id     client-id
                         :api-url       API_HOST
                         :extract-id    extract-id
                         :source-id     source-id
                         :uses-temporal (:source/uses-temporal source)}
        :submit         (submit-extract-config source-id extract-id extract extract-details-drawer?)}])))
